import { AxiosError } from 'axios';
import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { alimtalkQueryKeys } from '../../../constants/queryKeys/alimtalk';
import { AlimtalkApiV2 } from '../../../lib/api/alimtalk/AlimtalkApiV2';
import { AlimtalkTemplateList, AlimtalkTemplateListResponse } from '../../../types/alimtalk/template';

export const useAlimtalkTemplateListQuery = (params?: {
  activeOnly?: boolean;
}): UseQueryResult<AlimtalkTemplateList, AxiosError> =>
  useQuery(alimtalkQueryKeys.templateList(params), () => AlimtalkApiV2.getTemplateList(params), {
    // 백엔드 목록 응답은 { templates }로 래핑 — 소비처는 배열만 쓰므로 여기서 언랩
    select: (res: AlimtalkTemplateListResponse) => res.templates,
  });
